import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';


export class Tab {
  id: number;
  text: string;
  icon: string;
  content:string;
  save:boolean;
}

export class StudentTypeclass { 
  StudentType: string;
  StudentTypeName: string; 
}

export class  EntPreStudentCourseList{
  CollegeID: number
}
export class directadmission{
  EntPreStudentCollegeList:[{
    CollegeID:number;
    MediumID:number;
  }];
    StudentCourseID:number;
  StudentID:number;
  RegFormNo:number;
  CourseID:number;
  BranchID:number;
  CollegeID:number;
  SeatNo:number;
  Fees:number;
  RoundNo:number;
  AllotmentDate: string;
  JoiningDate:  string;
  AdmCatID:number;
  EntCenterID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  CreatedDate:string;
UpdatedDate:string;
  AllotmentFlag: string;
  DeleteFlag:string;
  RegConfirmFlag: string;
  DistrictID:number;
  ReceiptOrDDDate:string;
  ReceiptOrDDNo:number;
  PaymentFlag :string;
  AcademicInstanceID:number;
  AdmissionType:number;
  StudentType:string;
  
 // MediumID:number;
}
export class Meritadmission{
  StudentCourseID:number;
  StudentID:number;
  RegFormNo:number;
  CourseID:number;
  CourseName:string;
  BranchID:number;
  SeatNo:number;
  Fees:number;
  CollegeID:number;
  RoundNo:number;
  AllotmentDate: string;
  JoiningDate:  string;
  AdmCatID:number;
  EntCenterID:number;
  CreatedLoginID:number;
  UpdatedLoginID:number;
  CreatedDate:string;
  UpdatedDate:string;
  AllotmentFlag: string;
  DeleteFlag:string;
  RegConfirmFlag: string;
  DistrictID:number;
  ReceiptOrDDDate:string;
  ReceiptOrDDNo:number;
  PaymentFlag:string;
  AcademicInstanceID:number;
  AdmissionType:number;
  OnLinePaymentConfirmFlag:string;
  merchantTxnNo:number;
  payModeID:number;
  PaymentType:String;
  PurposeCode:number;
  customerName:string;
  customerEmailId:string;
  customerMobileNo:string;
  customerID:string;
  FeesAmount:number;
  CoursePartID:number;
  ExamInstanceID:number;
  StudentType:string;
  //MediumID:number;
}
export class Course
{
  CourseID:number;
  CourseName:string;
}
export class UsertDetailsStatus
{
     StudentID:number;
     StatusID :number; 
     StatusName :string;  
     StatusFlag :string; 
     profilePicPath:string;
     ProfileLockStatusFlag:string;
     chk:boolean;
     MultipleCourseApplyFlag:string="Y";
}
let tabs: Tab[] = [
  {
    id: 1,
    text: "Check List",
    icon: "doc",
    content:'checkList',
    save:false

  },

  {
    id: 2,
    text: "courses",
    icon: "doc",
    content:'courses',
    save:false

  },
  {
    id: 3,
    text: "Admission For",
    icon: "doc",
    content:'method',
    save:false
  }
];

let studType: StudentTypeclass[] = [
  {
    StudentType: 'R',
    StudentTypeName: "Regular"
  },

  {
    StudentType: 'D',
    StudentTypeName: "Distance"

  } 
];
export class DeclarationDetails{
  DeclarationDetailID :number;
  DeclarationType:string;
  DeclarationDescription: string;

}

export class Antiragging{
  AntiRaggingReferenceID :string;
  ABCIDReferenceID :string;
  PRNNOID :string;
  StudentID:number;
  //Antiraggingid: any;
}
@Injectable({
  providedIn: 'root'
})
export class AdmissionService {
  constructor(
    private dataService: DataAccessService) {
  }

  public getAllDistrict() {debugger
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'GetBasicDistrictForList?DistrictID=0'; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }

  public GetBasicDistrictByUniversity() {debugger
    this.dataService.setControllerName = '/BasicDistrict/';
    this.dataService.setMethodName = 'GetBasicDistrictByUniversity?DistrictID=0'; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }
  public getAllCity() {debugger
    this.dataService.setControllerName = '/BasicCity/';
    this.dataService.setMethodName = 'GetBasicCityList?BasicCityID=0'; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }

  public getAllCollege(DistrictID,CourseID,Gender,CollegeCityName) {debugger
    this.dataService.setControllerName = '/BasicCollege/';
    this.dataService.setMethodName = 'GetBasicCollegeByStateIDAndCityIDAndGender?DistrictID='+DistrictID+'&CourseID='+CourseID+'&Gender='+Gender+'&CollegeCityName='+CollegeCityName ; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }
    public getAllMedium(){
      this.dataService.setControllerName = '/BasicMedium/';
      this.dataService.setMethodName = 'GetBasicMediumList?MediumID=0';
       return this.dataService.getAll<directadmission[]>()
    }
  public getAllSchedule(CourseID) {debugger
    this.dataService.setControllerName = '/EntCourseSchedule/';
    this.dataService.setMethodName = 'GetEntCourseScheduleListForList?CourseID='+CourseID+''; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }
  public getAllScheduleForCET(CourseID,BranchID) {debugger
    this.dataService.setControllerName = '/EntCourseSchedule/';
    this.dataService.setMethodName = 'GetEntCourseScheduleListForListForCET?CourseID='+CourseID+'&BranchID='+BranchID; // setting method name from API controller.
    
    return this.dataService.getAll<directadmission[]>()
  }
  

  public directAdmissionsave(data) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'PostInsertEntPreStudentCourseListForDirect'; // setting method name from API controller.
    return this.dataService.add<directadmission[]>(data) 
  }
  public directAdmissionsaveForCollege(data) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'PostInsertEntPreStudentCourseListForDirectForCollege'; // setting method name from API controller.
    return this.dataService.add<directadmission[]>(data) 
  }
  public GetCourseData(CourseID) {debugger
    this.dataService.setControllerName = '/BasicCourse/';
    this.dataService.setMethodName = 'GetBasicCourseList?CourseID='+ CourseID; // setting method name from API controller.
    return this.dataService.getAll<Course[]>()
  }

  public MeritAdmissionsave(data) {debugger
    this.dataService.setControllerName = '/EntPreStudentCourse/';
    this.dataService.setMethodName = 'PostInsertEntPreStudentCourseForMerrit'; // setting method name from API controller.
    return this.dataService.add<Meritadmission[]>(data) 
  }
  public GetProfileLockStatusForAdmissionForm(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetProfileLockStatusForAdmissionForm?StudentID='+ StudentID; // setting method name from API controller.
    return this.dataService.getAll<UsertDetailsStatus[]>()
  }
  getTabs(): Tab[] {
    return tabs;
  }
  getStudentType():StudentTypeclass[]{
    return studType;
  }

  public updateAntiRaggingRefenceNo(data) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostPreStudentAntiRaggingRefenceNo'; // setting method name from API controller.
    return this.dataService.add<Antiragging[]>(data)
  }
  public GetAntiRaggingFormHTML(DeclarationType) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetAntiRaggingFormHTML?DeclarationType='+ DeclarationType; // setting method name from API controller.
    return this.dataService.getAll<DeclarationDetails[]>()
  }
  public getAntiRaggingReferenceIDByStudentID(StudentID) {debugger
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetAntiRaggingReferenceIDByStudentID?StudentID='+ StudentID; // setting method name from API controller.
    return this.dataService.getAll<Antiragging[]>()
  }
  
}
 

